<template>
  <div>
    <v-btn
      text
      x-small
      @click="reportProblem"
    >
      <v-icon>bug_report</v-icon>
      Report a Problem
    </v-btn>
    <confirm-dialog
      :value="confirmDialog"
      @input="onConfirm"
      title="Report a problem"
      :width="800"
      color="primary"
      confirmText="Send"
    >
      <p v-show="!!snapshot">
        To assist our team in solving your problem, we will use the following screenshot.
      </p>
      <v-img
        :src="snapshot"
        class="my-3"
        v-show="!!snapshot"
      />
      <p>
        Please use the area below to describe the problem as accurately as possible.
      </p>
      <v-form>
        <v-textarea
          label="Details"
          auto-grow
          v-model="comments"
        />
      </v-form>
      <p>
        Press the confirm button below to send your feedback to the MSA Team.
      </p>
    </confirm-dialog>

    <v-dialog
      v-model="doneDialog"
      width="300"
    >
    <v-card>
      <v-card-title class="text-h5">
        Report sent
      </v-card-title>
      <v-card-text>
        Thank-you for providing your feedback.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="primary"
          text
          @click="doneDialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
import log from 'loglevel'
import ConfirmDialog from './dialogs/ConfirmDialog.vue'
import { timeout, getEnv } from '../utilities'

export default {
  name: 'ReportProblem',

  components: {
    ConfirmDialog
  },

  data: () => ({
    confirmDialog: false,
    comments: '',
    snapshot: null,
    doneDialog: false
  }),

  methods: {
    async reportProblem () {
      await this.takeSnapshot()
      this.confirmDialog = true
    },

    async onConfirm (confirmed) {
      if (confirmed) {
        await this.sendReport()
        this.comments = ''
        this.snapshot = null
      }
      this.confirmDialog = false
    },

    async takeSnapshot () {
      try {
        log.info('Attempting to generate screenshot of DOM.')
        this.snapshot = await this.tryGetScreenCaptureUsingImageCapture()
      } catch (e) {
        log.error('Failed to generate snapshot of DOM.', e)
      }
    },

    async sendReport () {
      log.info('Collecting bug report information...')

      const url = new URL(getEnv('VUE_APP_REPORT_PROBLEM_HTTP'))
      const data = this.tryGetAppData()

      try {
        await fetch(url, {
          method: 'POST',
          mode: 'cors',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: this.encodeData(data),
            snapshot: this.snapshot,
            comments: this.comments
          })
        })
      } catch (e) {
        this.$emit('error', e)
        return
      }
      this.doneDialog = true
      log.info('Problem report sent.')
    },

    tryGetAppData () {
      const timestamp = new Date().toISOString()
      return {
        timestamp,
        store: this.$store.state,
        auth: {
          isAuthenticated: this.$auth.isAuthenticated,
          userProfile: this.$auth.userProfile,
          accessToken: this.$auth.accessToken
        }
      }
    },

    async tryGetScreenCaptureUsingImageCapture () {
      const stream = await navigator.mediaDevices.getDisplayMedia()
      const screenVideoTrack = stream.getVideoTracks()[0]
      const capture = new ImageCapture(screenVideoTrack)

      await timeout(250) // Wait for dialogs to close.
      const bitmap = await capture.grabFrame()
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('bitmaprenderer')

      canvas.width = bitmap.width
      canvas.height = bitmap.height
      context.transferFromImageBitmap(bitmap)
      stream.getTracks().forEach(track => track.stop())

      const frame = canvas.toDataURL('image/png')
      return frame
    },

    encodeData (data = {}) {
      return window.btoa(JSON.stringify(data))
    }
  }
}
</script>
